/**
 * Fills missing alt text on content images that arrive as raw HTML
 * (page content, bank-promotion modals). Theme sections set alt in Liquid;
 * this only runs when alt is still empty and the image is not decorative.
 */
function fillContentImageAlts(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const images = scope.tagName === 'IMG' ? [scope] : scope.querySelectorAll('img');

  images.forEach((img) => {
    if (img.getAttribute('aria-hidden') === 'true') return;
    if (img.getAttribute('role') === 'presentation' || img.getAttribute('role') === 'none') return;
    if (img.closest('[aria-hidden="true"], button')) return;

    const current = (img.getAttribute('alt') || '').trim();
    if (current) return;

    const container = img.closest(
      'figure, section, article, .rte, .collage-card, .partner_cards, .image_with_text_tile_box, .ac-modal, [role="dialog"]'
    );
    const heading = container
      ? container.querySelector('h1, h2, h3, h4, .content_heading, .image_heading, .PartnerHeading')
      : null;
    let label = heading ? heading.textContent.trim() : '';

    if (!label) {
      const link = img.closest('a');
      if (link) label = (link.getAttribute('aria-label') || link.textContent || '').trim();
    }

    if (!label) label = (img.getAttribute('title') || '').trim();

    if (!label) {
      const src = img.getAttribute('src') || '';
      const fileName = decodeURIComponent(src.split('?')[0].split('/').pop() || '');
      const readable = fileName
        .replace(/\.[a-z0-9]+$/i, '')
        .replace(/^\d{6,8}-[a-z0-9]+-/i, '')
        .replace(/[-_]+/g, ' ')
        .trim();
      if (readable && /[a-z]/i.test(readable) && readable.length > 2) label = readable;
    }

    if (!label) label = (document.title || '').replace(/\s+[–|-].*$/, '').trim();
    if (label) img.setAttribute('alt', label);
  });
}

window.fillContentImageAlts = fillContentImageAlts;

document.addEventListener('DOMContentLoaded', function () {
  fillContentImageAlts(document);
});
